import React, { useState } from 'react';
import Reveal from './Reveal';
import { PREVIEW_VIDEO_ID } from './courseContent';
import './courseKit.css';

/**
 * Free class preview. Udemy requires previewable lecture content because it is
 * one of the strongest enrollment levers, and it is the most direct way to
 * raise Hormozi's "perceived likelihood of achievement" term: people can see
 * the teaching before they buy.
 *
 * Click-to-load rather than an eager iframe, so YouTube does not run on every
 * page view and the page stays fast.
 */
const PreviewVideo = ({
  videoId = PREVIEW_VIDEO_ID,
  heading = 'Watch a real class before you decide',
  blurb = 'This is Rob teaching, unedited. Same voice, same pace, same level of detail you get in the live sessions.',
}) => {
  const [playing, setPlaying] = useState(false);

  return (
    <section className="ck-preview" aria-label="Class preview">
      <Reveal><h2>{heading}</h2></Reveal>
      <Reveal delay={70}><p className="ck-preview-blurb">{blurb}</p></Reveal>
      <Reveal delay={120}>
        <div className="ck-preview-frame">
          {playing ? (
            <iframe
              src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`}
              title="Bootcamp class preview"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              loading="lazy"
            />
          ) : (
            <button
              type="button"
              className="ck-preview-poster"
              onClick={() => setPlaying(true)}
              aria-label="Play the class preview"
              data-testid="preview-play"
            >
              <img
                src={`https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`}
                alt=""
                loading="lazy"
                width="480"
                height="360"
              />
              <span className="ck-preview-play" aria-hidden="true" />
            </button>
          )}
        </div>
      </Reveal>
    </section>
  );
};

export default PreviewVideo;
